// helpers/HelperFunctions.tsx

import { AccountTypeClassification } from './HelperInterfaces';
import { DEFAULT_MAX_CHARACTERS } from './HelperConstants';


export function classifyAccountType(accountType: string): AccountTypeClassification {
    switch (accountType) {
        case 'Investment':
        case 'Cash':
        case 'Checking':
        case 'Savings':
        case 'Cryptocurrency':
            return { isExpense: false, isIncome: true };
        case 'Credit Card':
        case 'Loan':
            return { isExpense: true, isIncome: false };
        default:
            return { isExpense: false, isIncome: false };
    }
};

export function showLimitedCharacters(
    string: string, limit: number = 30
): string {
    if (string.length > 20){
        let substring = string.substring(0, limit);
        return `${substring}...`;
    } else {
        return string
    }
}

export function isStringValid(
    string: string
): [boolean, string] {
    // if (string.includes("'")){
    //     return [false, "Please do not include '\"'."]
    // }
    if (string.length > DEFAULT_MAX_CHARACTERS) {
        return [false, `Try less than ${DEFAULT_MAX_CHARACTERS} characters.`]
    }
    else {
        return [true, ""]
    }
}